"use strict";
exports.__esModule = true;
exports.Day = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var class_names_1 = tslib_1.__importDefault(require("../../../utils/class-names"));
var ui_kit_1 = require("@pezeshk-book/ui-kit");
var Day = function (props) {
    var children = props.children, disabledDay = props.disabledDay, holidays = props.holidays, passedDay = props.passedDay, comingDay = props.comingDay, selectedDay = props.selectedDay, selected = props.selected, handleDay = props.handleDay, isRange = props.isRange, startRange = props.startRange, endRange = props.endRange;
    if (!children) {
        return (0, jsx_runtime_1.jsx)(ui_kit_1.Div, tslib_1.__assign({}, props));
    }
    var color = passedDay ? 'control' : selected ? 'primary' : isRange ? 'slate' : selectedDay ? 'primary' : (disabledDay || holidays ? 'danger' : 'inherit');
    var variant = selected ? 'filled' : (isRange ? 'outlined' : 'text');
    return ((0, jsx_runtime_1.jsx)(ui_kit_1.Button, tslib_1.__assign({ disabled: comingDay || passedDay, variant: variant, rounded: isRange ? 'none' : 'medium', size: 'medium', shape: 'square', color: color, className: (0, class_names_1["default"])(isRange ? 'border-l-0 border-r-0 border-dashed' : '', startRange && isRange ? 'rounded-r-lg rounded-l-none' : '', endRange && isRange ? 'rounded-l-lg rounded-r-none' : ''), onClick: handleDay }, props)));
};
exports.Day = Day;
//# sourceMappingURL=day.js.map